<div *ngIf="loaderService.isLoading$ | async" 
     class="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black/50 backdrop-blur-sm">
  
  <div class="relative flex h-20 w-20 items-center justify-center">
    <div class="absolute h-full w-full animate-spin rounded-full border-4 border-solid border-blue-500 border-t-transparent"></div>
    <div class="absolute h-12 w-12 animate-ping rounded-full bg-blue-400 opacity-20"></div>
  </div>

  <p class="mt-4 font-medium text-white animate-pulse">Processing...</p>
</div>